import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { RoutesEnum } from '@enums/routes.enum';
import { GlobalStoreService } from '@modules/global/store/global-store.service';
import { ExternalChatParamsI } from '@components/common/external-chat-loader/external-chat-loader.component';

@Injectable({
  providedIn: 'root',
})
export class RubeusIntegrationHelperService {
  constructor(private globalStoreService: GlobalStoreService, private router: Router) {}

  public async checkForIntegration() {
    const params = await this.globalStoreService.getQueryParams();
    const { rubeusContact, clientId, parameterId } = params || {};
    if (rubeusContact && clientId && parameterId) {
      this.router.navigate(['/external-chat'], {
        state: {
          rubeus: {
            paramenterId: parameterId,
            clientId: clientId,
          },
        } as ExternalChatParamsI,
      });
    }
  }
}
